import {forwardRef} from "react";
import {Box, BoxProps, Button, Combobox, useCombobox} from "@mantine/core";
import cx from "clsx";
import {IconChevronDown} from "@tabler/icons-react";

export interface IRoute {
    default?: boolean,
    path: string,
    name: string
}

type ProtocolSelectorProps = {
    activeRoute?: IRoute,
    routes: Array<IRoute>
    onRouteSelected: (route: IRoute) => void
} & BoxProps

export const RouteSelector = forwardRef<HTMLDivElement, ProtocolSelectorProps>(({
                                                                                    className,
                                                                                    activeRoute,
                                                                                    routes,
                                                                                    onRouteSelected,
                                                                                    ...others
                                                                                }, ref) => {
        const combobox = useCombobox({
            onDropdownClose: () => combobox.resetSelectedOption(),
        });
        const renderRouteOptions = () => {
            return routes.map((r) => <Combobox.Option key={r.path} value={r.path}>{r.name}</Combobox.Option>)
        }
        return (
            <Box ref={ref} className={cx(className)} {...others} style={{display:"grid", grid:"auto / auto"}}>
                <Combobox store={combobox}
                          onOptionSubmit={(path) => {
                              combobox.closeDropdown()
                              const route = routes.find((r) => r.path === path)
                              route && onRouteSelected(route)
                          }}
                >
                    <Combobox.Target>
                        <Button
                            rightSection={<IconChevronDown size="1rem"/>}
                            onClick={() => combobox.toggleDropdown()}
                            style={{textAlign: "center"}}
                        >
                                {activeRoute?.name}
                        </Button>
                    </Combobox.Target>
                    <Combobox.Dropdown>
                        <Combobox.Options>
                            {renderRouteOptions()}
                        </Combobox.Options>
                    </Combobox.Dropdown>

                </Combobox>
            </Box>
        )
    }
)